import { toast as sonnerToast } from "sonner";

const DISMISS_MS = 2500;

function withAutoDismiss(fn) {
  return (message, options) => {
    const id = fn(message, { duration: DISMISS_MS, ...options });
    setTimeout(() => sonnerToast.dismiss(id), options?.duration || DISMISS_MS);
    return id;
  };
}

const toast = Object.assign(withAutoDismiss(sonnerToast), {
  success: withAutoDismiss(sonnerToast.success),
  error: withAutoDismiss(sonnerToast.error),
  info: withAutoDismiss(sonnerToast.info),
  warning: withAutoDismiss(sonnerToast.warning),
  loading: sonnerToast.loading,
  promise: sonnerToast.promise,
  dismiss: sonnerToast.dismiss,
});

export { toast };
